import { NativeStackHeaderProps, router, Stack } from 'expo-router';
import TabaPayAddressScreen from 'features/moveMoney/screens/dcf/tabapay/TabapayAddress/TabaPayAddressScreen';
import React from 'react';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';

export default function TabapayAddressScreenPage() {
  const handleBackButtonAction = () => {
    router.back();
  };
  return (
    <>
      <Stack.Screen
        options={{
          headerShown: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              primaryOnPress={handleBackButtonAction}
            />
          ),
        }}
      />
      <TabaPayAddressScreen screenType="tabapay" />
    </>
  );
}
